import React, {useState} from 'react';
import {Link} from 'react-router-dom';

import Head from './head';
import Nav from './nav';
import Footer from './footer';
import Scripts from './scripts';
import './css/recommend.css';
import './css/btn.css';
import {API_BASE} from "../apiConfig";

function Recommendation (){

	const [single, setSinglePreference] = useState(false);
	const [double, setDoublePreference] = useState(false);
	const [triple, setTriplePreference] = useState(false);
	const [quad, setQuadPreference] = useState(false);
	const [suite, setSuitePreference] = useState(false);
	const [location, setLocationPreference] = useState("");
	const [bathroom, setBathroomPreference] = useState("");
	const [floor, setFloorPreference] = useState("");
	const [commonRoom, setCommonRoomPreference] = useState("");
	const [elevator, setElevatorPreference] = useState("");

	// post request to send survey data to backend
	const submitSurvey = () => {
		let postParameters = {
			"singlePreference": single,
			"doublePreference": double,
			"triplePreference": triple,
			"quadPreference": quad,
			"suitePreference": suite,
			"location": location,
			"bathroom": bathroom,
			"floor": floor,
			"commonRoom": commonRoom,
			"elevator": elevator,
		};
		fetch(`${API_BASE}/submitSurvey`, {
			method: 'post', body: JSON.stringify(postParameters),
			headers: {"Access-Control-Allow-Origin": "*"}
		})
	}

	return (
	<div className="recommend">
		<Head/>
		<Nav/>

		<div className="recommend-header">
			<h1>What dorm is right for you?</h1>
			<p>Answer a few questions and we'll put together a short list worth touring.</p>
		</div>

		<form id="msform">
			<div>
				<div className="q-label">What room style(s) would work for you?</div>
				<div className="q-sub">Select all that apply</div>
				<div className="pill-row">
					<label>
						<input type="checkbox" name="checkbox" className="room_style" id="Single"
							   onClick={() => setSinglePreference(current => !current)}/>
						<span>Single</span>
					</label>
					<label>
						<input type="checkbox" name="checkbox" className="room_style" id="Double"
							   onClick={() => setDoublePreference(current => !current)}/>
						<span>Double</span>
					</label>
					<label>
						<input type="checkbox" name="checkbox" className="room_style" id="Triple"
							   onClick={() => setTriplePreference(current => !current)}/>
						<span>Triple</span>
					</label>
					<label>
						<input type="checkbox" name="checkbox" className="room_style" id="Quad"
							   onClick={() => setQuadPreference(current => !current)}/>
						<span>Quad</span>
					</label>
					<label>
						<input type="checkbox" name="checkbox" className="room_style" id="Suite"
							   onClick={() => setSuitePreference(current => !current)}/>
						<span>Suite</span>
					</label>
				</div>
			</div>

			<div>
				<div className="q-label">Where do you prefer to live?</div>
				<div className="q-sub">Pick one</div>
				<div className="pill-row">
					<label>
						<input type="radio" name="location" className="location" id="North Campus"
							   onClick={() => setLocationPreference("North Campus")}/>
						<span>North Campus</span>
					</label>
					<label>
						<input type="radio" name="location" className="location" id="Center Campus"
							   onClick={() => setLocationPreference("Center Campus")}/>
						<span>Center Campus</span>
					</label>
					<label>
						<input type="radio" name="location" className="location" id="South Campus"
							   onClick={() => setLocationPreference("South Campus")}/>
						<span>South Campus</span>
					</label>
				</div>
			</div>

			<div>
				<div className="q-label">How important is having a private bathroom?</div>
				<div className="q-sub">Pick one</div>
				<div className="pill-row">
					<label>
						<input type="radio" name="bathroom" className="bathroom" id="Not Important"
							   onClick={() => setBathroomPreference("Not Important")}/>
						<span>Not important</span>
					</label>
					<label>
						<input type="radio" name="bathroom" className="bathroom" id="Neutral"
							   onClick={() => setBathroomPreference("Neutral")}/>
						<span>Neutral</span>
					</label>
					<label>
						<input type="radio" name="bathroom" className="bathroom" id="Important"
							   onClick={() => setBathroomPreference("Important")}/>
						<span>Important</span>
					</label>
				</div>
			</div>

			<div>
				<div className="q-label">What type of floor would you prefer?</div>
				<div className="q-sub">Pick one</div>
				<div className="pill-row">
					<label>
						<input type="radio" name="floor" className="floor" id="Hardwood"
							   onClick={() => setFloorPreference("Hardwood")}/>
						<span>Hardwood</span>
					</label>
					<label>
						<input type="radio" name="floor" className="floor" id="Carpeted"
							   onClick={() => setFloorPreference("Carpeted")}/>
						<span>Carpeted</span>
					</label>
					<label>
						<input type="radio" name="floor" className="floor" id="No Preference"
							   onClick={() => setFloorPreference("No Preference")}/>
						<span>No preference</span>
					</label>
				</div>
			</div>

			<div>
				<div className="q-label">How important is having a common room?</div>
				<div className="q-sub">Pick one</div>
				<div className="pill-row">
					<label>
						<input type="radio" name="commonRoom" className="commonRoom" id="Not Important"
							   onClick={() => setCommonRoomPreference("Not Important")}/>
						<span>Not important</span>
					</label>
					<label>
						<input type="radio" name="commonRoom" className="commonRoom" id="Neutral"
							   onClick={() => setCommonRoomPreference("Neutral")}/>
						<span>Neutral</span>
					</label>
					<label>
						<input type="radio" name="commonRoom" className="commonRoom" id="Important"
							   onClick={() => setCommonRoomPreference("Important")}/>
						<span>Important</span>
					</label>
				</div>
			</div>

			<div>
				<div className="q-label">How important is having an elevator?</div>
				<div className="q-sub">Pick one</div>
				<div className="pill-row">
					<label>
						<input type="radio" name="elevator" className="elevator" id="Not Important"
							   onClick={() => setElevatorPreference("Not Important")}/>
						<span>Not important</span>
					</label>
					<label>
						<input type="radio" name="elevator" className="elevator" id="Neutral"
							   onClick={() => setElevatorPreference("Neutral")}/>
						<span>Neutral</span>
					</label>
					<label>
						<input type="radio" name="elevator" className="elevator" id="Important"
							   onClick={() => setElevatorPreference("Important")}/>
						<span>Important</span>
					</label>
				</div>
			</div>

			<div className="recommend-submit">
				<Link className="btn-primary" onClick={submitSurvey} to="/recommendation-results">
					Get Recommendations
					<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="#fff" strokeWidth="1.8"><path d="M7 4l6 6-6 6" strokeLinecap="round" strokeLinejoin="round"/></svg>
				</Link>
				<span className="hint">Takes about two minutes</span>
			</div>
		</form>

		<Footer/>
		<Scripts/>
	</div>
	)
}

export default Recommendation;
